export default __webpack_public_path__ + "static/media/icon-warning.658755af.svg";